// extracted by mini-css-extract-plugin
module.exports = {"logosContainer":"trusted-by_logosContainer__qHXu_","scrollingHeader":"trusted-by_scrollingHeader__ogZpX","nonScrollingHeader":"trusted-by_nonScrollingHeader__mWYpm"};